import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Link from '../utils/link'
import Seo from '../components/seo'
import he from 'he'
import Breadcrumb from '../assets/images/breadcrumb.svg'
import Twitter from '../assets/images/twitter.svg'
import LinkedIn from '../assets/images/linkedin-dark.svg'
import Facebook from '../assets/images/facebook-dark.svg'
import Email from '../assets/images/email-dark.svg'
import PhoneGrey from '../assets/images/phone-dark.svg'
import LandSize from '../assets/images/land-size.svg'
import Bed from '../assets/images/bed.svg'
import Bath from '../assets/images/bath.svg'
import Car from '../assets/images/car.svg'
import Auction from '../assets/images/auction.svg'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade'
import AddToCalendarHOC from 'react-add-to-calendar-hoc'
import moment from 'moment'
import LightBox from '../components/lightbox'
import FsLightbox from 'fslightbox-react'
import Plyr from '../components/plyr'
import Map from '../components/map'
import SuburbSnapshot from '../components/suburb-snapshot'
import PropertyForm from '../components/property-form'
import AgentCard from '../components/card/agent'
import PropertyCard from '../components/card/property'
import { RightPlayArrow, Download, Calendar } from '../components/icons'
import Cta from '../components/cta'

function filterIt(arr, searchKey) {
  return arr.filter(function (obj) {
    return Object.keys(obj).some(function (key) {
      return obj[key].includes(searchKey)
    })
  })
}

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{this.props.children}</>)
  }
}

class PropertyTemplate extends Component {

  state = {
    videoLightbox: false,
    floorplanLightbox: false,
    tour3dLightbox: false,
    imageLightbox: false,
    enquiry: false,
    shareLink: '',
  }

  componentDidMount() {
    this.setState({ shareLink: window.location.href })

    const property = this.props.data.wpProperty
    const agent = this.props.data.agent1

    window.loopaData = {
      "ProductId": property.meta.listing_id,
      "Price": property.meta.price,
      "Bedrooms": property.meta.bedrooms,
      "Region": property.meta.address_state,
      "District": property.meta.address_suburb,
      "Address": property.title,
      "HousingType": property.meta.property_type,
      "SaleType": property.meta.listing_type,
      "Agent Name": agent?.title,
      "Agent Image": agent?.acf?.thumbnailImage?.sourceUrl,
      "Agent Phone": agent?.teamData?.mobile || agent?.node?.teamData?.acf?.mobile
    };
  }

  renderText = (el, i) => {
    let text = el.trim()
    if (text.length === 0) return
    //if (el.length < 20 && el.indexOf('•') === -1) return <h4 key={i}>{ el }</h4>
    if (text.indexOf('•') !== -1) return <li key={i}>{text.replace(/•/gi, '')}</li>
    if (text.indexOf('-') === 0) return <li key={i}>{text.substring(1)}</li>
    return <p key={i}>{text}</p>
  }

  renderChatButton = () => {
    const { meta } = this.props.data.wpProperty
    if (meta.property_status === 'Sold') return null

    let slug = `${meta.address_street_number}-${meta.address_street_name}-${meta.address_street_type}-${meta.address_suburb.replace(/\s/g, '-')}-${meta.address_state}-${meta.address_postcode}`
    if (meta.address_sub_number !== '') slug = `${meta.address_sub_number}-${slug}`

    return (
      <Link to={`https://reach.hodges.com.au/${slug.toLowerCase()}`} className='btn btn--cancel'>
        Chat with us
      </Link>
    )
  }

  renderArea() {
    const property = this.props.data.wpProperty
    // Check area exists
    if (!property.area || property.area.length === 0) return null
    // Find first area that isn't null or 0
    const area = property.area.find(el => el.area !== null && el.area !== "0.00")
    if (!area) return null
    return (
      <p>
        <img src={LandSize} alt='Land Size' />
        {parseInt(area.area) > 10000 && <span>{parseFloat(area.area / 10000).toFixed(1)}ha <small>(approx.)</small></span>}
        {parseInt(area.area) < 10000 && <span>{parseInt(area.area)}{area.area_unit === 'Acre' ? ' Acres' : 'm2'} <small>(approx.)</small></span>}
      </p>
    )
  }

  render() {

    let property = this.props.data.wpProperty
    let related = this.props.data.related
    let { snapshotCta, singlePropertyCta } = this.props.data.wp.siteSettings.acf

    const { agent1, agent2, agent3, agent4 } = this.props.data
    let agents = []
    if (agent1) agents.push(agent1)
    if (agent2) agents.push(agent2)
    if (agent3) agents.push(agent3)
    if (agent4) agents.push(agent4)

    // make sure agents are unique
    agents = agents.filter((el, i) => {
      return agents.findIndex((e) => {
        return e.teamData.agent_id === el.teamData.agent_id
      }) === i
    })

    let { videoLightbox, floorplanLightbox, tour3dLightbox, imageLightbox, enquiry, shareLink } = this.state

    let videoUrl = ''
    let player = 'youtube'
    let video = property.media?.length && filterIt(property.media, 'youtu')
    if (!video) video = property.media?.length && filterIt(property.media, 'vimeo')
    if (video && video.length) {
      videoUrl = video[0].url
      player = videoUrl.indexOf('vimeo') !== -1 ? "vimeo" : "youtube"
    }
    if (!videoUrl && property.acf.videoUrl) {
      videoUrl = property.acf.videoUrl
      player = videoUrl.indexOf('vimeo') !== -1 ? "vimeo" : "youtube"
      player = videoUrl.indexOf('.mp4') !== -1 ? "html5" : player
      console.log(player, videoUrl)
    }

    let tour3d = ''
    let external = property.media?.length && filterIt(property.media, 'external')
    if (external && external.length) {
      tour3d = external[0].url
    }

    let soi = property.media?.length && filterIt(property.media, 'application/pdf')
    if (soi && soi.length > 0) {
      soi = soi[0].url
    } else {
      soi = '';
    }

    const ATCDropdown = (args) => (
      <ul className="atc-dropdown">
        {args.children.map((link, i) => (
          <li key={i}>{link}</li>
        ))}
      </ul>
    );

    const ATCWrapper = (args) => (
      <a onClick={args.onClick} className="atc-item" href="/">
        <span dangerouslySetInnerHTML={{ __html: args.children }} />
      </a>
    );

    const AddToCalendarDropdown = AddToCalendarHOC(ATCWrapper, ATCDropdown);
    let duration = 1;
    let auctionEvent = {
      description: 'Auction',
      duration,
      endDatetime: moment(property.meta.auction_date + ' ' + property.meta.auction_time).add(1, 'hours').format("YYYYMMDDTHHmmss"),
      location: property.meta.address_hide ? property.meta.address_suburb : property.title,
      startDatetime: moment(property.meta.auction_date + ' ' + property.meta.auction_time).format("YYYYMMDDTHHmmss"),
      title: `Auction: ${property.meta.address_hide ? property.meta.address_suburb : property.title}`,
    }
    let inspectionEvent = {}

    let hasInspections = false
    if (property.inspections?.length > 0) {
      property.inspections.map((el, i) => {
        if (moment(el.inspection_date, "YYYY-MM-DD").isAfter(new Date())) hasInspections = true
      })
    }

    const settings = {
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      cssEase: 'ease',
      pauseOnHover: false,
      focusOnSelect: false,
      adaptiveHeight: true,
    }

    return (
      <>
        <Seo
          title={he.decode(property.seo.title)}
          path={this.props.pageContext.pathName}
          bodyClass={'single-property'}
          description={property.seo.metaDesc}
          keywords={property.seo.metaKeywords}
          schema={property.seo.schema.raw}
          src={property.images?.length > 0 && property.images[0].img}
        />
        <section className='property-header'>
          <div className='breadcrumbs'>
            <div className='breadcrumbs__inner'>
              <ul>
                <li>
                  <Link to='/'>Home</Link>
                  <img src={Breadcrumb} alt='Hodges' />
                </li>
                <li>
                  <Link to={property.meta.property_status === 'Sold' ? '/sold-properties/' : '/properties-for-sale/'}>{property.meta.property_status === 'Sold' ? 'Sold' : 'For Sale'}</Link>
                  <img src={Breadcrumb} alt='Hodges' />
                </li>
                <li>
                  <span>{property.meta.address_hide ? property.meta.address_suburb : property.title}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className='property-header__slider'>
            <Slider {...settings}>
              {property.images?.length > 0 && property.images.map((el, i) => (
                <img src={el.img} alt={property.meta.address_hide ? property.meta.address_suburb : property.title} key={i} onClick={() => this.setState({ imageLightbox: !imageLightbox })} />
              ))}
            </Slider>
            <ul className='property-header__buttons'>
              {videoUrl !== '' &&
                <li>
                  <button
                    className='video__play'
                    onClick={() => this.setState({ videoLightbox: !videoLightbox })}
                  >
                    <RightPlayArrow color={'#52545C'} />
                    <span>Video</span>
                  </button>
                </li>
              }
              {tour3d !== '' &&
                <li>
                  <button
                    className='video__play'
                    onClick={() => this.setState({ tour3dLightbox: !tour3dLightbox })}
                  >
                    <RightPlayArrow color={'#52545C'} />
                    <span>3D Tour</span>
                  </button>
                </li>
              }
              {property.meta.floorplan?.length > 0 &&
                <li>
                  <button
                    className='video__play'
                    onClick={() => this.setState({ floorplanLightbox: !floorplanLightbox })}
                  >
                    <span>Floorplan</span>
                  </button>
                </li>
              }
            </ul>
          </div>
          <div className={`property-header__content${property.meta.property_status === 'Sold' ? ' sold' : ''}`}>
            <div className='property-header__inner'>
              <div className='property-header__left'>
                <h6><span>{property.meta.property_status === 'Sold' ? 'SOLD' : 'For Sale'}</span></h6>
                <h1>{he.decode(property.title)}</h1>
              </div>
              <div className='property-header__right'>
                <div className='property-header__meta'>
                  <ul>
                    {property.meta.bedrooms > 0 &&
                      <li>
                        <span>{property.meta.bedrooms}</span>
                        <img src={Bed} alt='Beds' />
                      </li>
                    }
                    {property.meta.bathrooms > 0 &&
                      <li>
                        <span>{property.meta.bathrooms}</span>
                        <img src={Bath} alt='Baths' />
                      </li>
                    }
                    {property.meta.parking_total > 0 &&
                      <li>
                        <span>{property.meta.parking_total}</span>
                        <img src={Car} alt='Cars' />
                      </li>
                    }
                  </ul>
                  {this.renderArea()}
                </div>
                <div className='property-header__prices'>
                  {property.meta.property_status !== 'Sold' && soi &&
                    <div className='property-header__soi'>
                      <Link to={soi}>Statement of Information <Download color={'#1C1C1C'} /></Link>
                    </div>
                  }
                  {property.meta.property_status === 'Sold' &&
                    <div className='property-header__soi'>
                      <img src={Auction} alt='Hodges - Auction' />
                      SOLD {moment(property.meta.sold_details_sold_date).format('ddd D MMM YYYY')}
                    </div>
                  }
                  {property.meta.property_status !== 'Sold' &&
                    <div className='property-header__price'>
                      {property.meta.price_display ? property.meta.price_view : 'Contact Agent'}
                    </div>
                  }
                  {property.meta.property_status === 'Sold' &&
                    <div className='property-header__price'>
                      {property.meta.sold_details_sold_price_display ? `$${parseFloat(property.meta.sold_details_sold_price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\.00/, '')}` : 'Contact Agent'}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='property-content'>
          <div className='property-content__inner'>
            <div className='property-content__dates property-content__dates--mobile'>
              {property.meta.auction_date &&
                <div className='property-content__auctions'>
                  <h4>Auction</h4>
                  <ul>
                    <li>
                      <Calendar color={'#1C1C1C'} />
                      <AddToCalendarDropdown buttonText={`${moment(property.meta.auction_date).format('ddd D MMM YYYY')}<br />${moment(property.meta.auction_date + ' ' + property.meta.auction_time).format('h:mm a')}`} event={auctionEvent} />
                    </li>
                  </ul>
                </div>
              }
              {hasInspections &&
                <div className='property-content__inspections'>
                  <h4>Inspections</h4>
                  <ul>
                    {property.inspections.map((el, i) => {
                      inspectionEvent = {
                        description: 'Inspection',
                        duration,
                        endDatetime: moment(el.inspection_date + ' ' + el.inspection_end_time).format("YYYYMMDDTHHmmss"),
                        location: property.meta.address_hide ? property.meta.address_suburb : property.title,
                        startDatetime: moment(el.inspection_date + ' ' + el.inspection_start_time).format("YYYYMMDDTHHmmss"),
                        title: `Inspection: ${property.meta.address_hide ? property.meta.address_suburb : property.title}`,
                      }
                      if (moment(el.inspection_date, "YYYY-MM-DD").add(1, 'days').isBefore(new Date())) return false
                      return (
                        <li key={i}>
                          <Calendar color={'#1C1C1C'} />
                          <AddToCalendarDropdown buttonText={`${moment(el.inspection_date).format('ddd D MMM YYYY')}<br />${moment(el.inspection_date + ' ' + el.inspection_start_time).format('h:mm a')} - ${moment(el.inspection_date + ' ' + el.inspection_end_time).format('h:mm a')}`} event={inspectionEvent} />
                        </li>
                      )
                    })}
                  </ul>
                </div>
              }
            </div>
            <div className='property-content__left'>
              <div className='property-content__dates property-content__dates--desktop'>
                {property.meta.auction_date &&
                  <div className='property-content__auctions'>
                    <h4>Auction</h4>
                    <ul>
                      <li>
                        <Calendar color={'#1C1C1C'} />
                        <AddToCalendarDropdown buttonText={`${moment(property.meta.auction_date).format('ddd D MMM YYYY')}<br />${moment(property.meta.auction_date + ' ' + property.meta.auction_time).format('h:mm a')}`} event={auctionEvent} />
                      </li>
                    </ul>
                  </div>
                }
                {hasInspections &&
                  <div className='property-content__inspections'>
                    <h4>Inspections</h4>
                    <ul>
                      {property.inspections?.map((el, i) => {
                        inspectionEvent = {
                          description: 'Inspection',
                          duration,
                          endDatetime: moment(el.inspection_date + ' ' + el.inspection_end_time).format("YYYYMMDDTHHmmssZ"),
                          location: property.meta.address_hide ? property.meta.address_suburb : property.title,
                          startDatetime: moment(el.inspection_date + ' ' + el.inspection_start_time).format("YYYYMMDDTHHmmssZ"),
                          title: `Inspection: ${property.meta.address_hide ? property.meta.address_suburb : property.title}`,
                        }
                        if (moment(el.inspection_date, "YYYY-MM-DD").add(1, 'days').isBefore(new Date())) return false
                        return (
                          <li key={i}>
                            <Calendar color={'#1C1C1C'} />
                            <AddToCalendarDropdown buttonText={`${moment(el.inspection_date).format('ddd D MMM YYYY')}<br />${moment(el.inspection_date + ' ' + el.inspection_start_time).format('h:mm a')} - ${moment(el.inspection_date + ' ' + el.inspection_end_time).format('h:mm a')}`} event={inspectionEvent} />
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                }
              </div>
              <div className='property-content__buttons'>
                <button type='button' className={`btn ${property.meta.property_status === 'Sold' && 'btn--full-width'}`} onClick={() => this.setState({ enquiry: !enquiry })}>
                  Enquire
                </button>
              </div>
              <div className='property-content__agents'>
                {agents?.map((el, i) => {
                  let agentProps = {
                    image: el.acf?.thumbnailImage ? el.acf.thumbnailImage : '',
                    title: el.title,
                    office: el.acf?.office?.length > 0 ? el.acf.office[0] : 'Hodges',
                    phone: el.acf?.mobile ? el.acf?.mobile : el.teamData?.mobile,
                    email: el.acf?.email ? el.acf?.email : el.teamData?.email,
                    link: `/team/${el.slug}/`,
                    role: el.acf?.jobTitle
                  }
                  return (
                    <div key={i}>
                      <AgentCard {...agentProps} />
                    </div>
                  )
                })}
              </div>
            </div>
            <div className='property-content__right'>
              <h2>{property.meta.headline}</h2>
              <div className='property-content__description'>
                {property.meta?.description.split('\n').map(this.renderText)}
                <ul className='single-property__share'>
                  <li>SHARE</li>
                  <li>
                    <Link to={`mailto:?body=${shareLink}`}>
                      <img src={Email} alt='Email' />
                    </Link>
                  </li>
                  <li>
                    <Link to={`sms:&body=${shareLink}`}>
                      <img src={PhoneGrey} alt='SMS' />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//www.linkedin.com/shareArticle?mini=true&url=${shareLink}&title=${he.decode(property.title)}`}>
                      <img src={LinkedIn} alt='LinkedIn' />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//www.facebook.com/sharer/sharer.php?u=${shareLink}`}>
                      <img src={Facebook} alt='Facebook' />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//twitter.com/home?status=${shareLink}`}>
                      <img src={Twitter} alt='Twitter' />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='property-map'>
          <BlockUpdate>
            <Map latitude={property.meta.latitude} longitude={property.meta.longitude} />
          </BlockUpdate>
        </section>
        {videoUrl !== '' && videoLightbox &&
          <LightBox active={videoLightbox} closeFunc={() => this.setState({ videoLightbox: !videoLightbox })}>
            <Plyr
              provider={player}
              ref='player'
              videoId={player !== 'html5' && videoUrl}
              url={player === 'html5' && videoUrl}
              autoplay={true}
              urls={{
                youtube: {
                  api: 'https://noembed.com/embed?url={0}'
                },
              }}
            />
          </LightBox>
        }
        {tour3d !== '' && tour3dLightbox &&
          <LightBox active={tour3dLightbox} closeFunc={() => this.setState({ tour3dLightbox: !tour3dLightbox })}>
            <div className='single-property__iframe'>
              <iframe src={tour3d} width='100%' height='100%' />
            </div>
          </LightBox>
        }
        {property.meta.floorplan?.length > 0 &&
          <FsLightbox
            toggler={floorplanLightbox}
            sources={[
              <img className='single-property__floorplan-image' src={property.meta.floorplan} alt='Floorplan' />
            ]}
          />
        }
        {property.images?.length > 0 &&
          <FsLightbox
            toggler={imageLightbox}
            sources={property.images.map((el, idx) => (
              <img
                key={idx}
                src={el.img}
                className='single-property__lightbox-image'
              />
            ))}
          />
        }
        <SuburbSnapshot title={`${property.meta.address_suburb} - ${property.meta.address_postcode}`} link={`/suburb/${property.meta.address_suburb.replace(/\s/g, '-').toLowerCase()}-${property.meta.address_postcode}/`} {...snapshotCta} />
        {related && related.edges.length > 0 &&
          <section className='single-property__properties'>
            <div className='single-property__inner'>
              <div className='single-property__related'>
                <h4>We think you'll also like...</h4>
                <Link className='btn' to={`/properties-for-sale/?search=${property.meta.address_suburb}`}>View More</Link>
              </div>
              <div className='archive__items archive__items--related'>
                {related.edges.slice(0, 3).map((el, i) => {
                  let title = el.node.title
                  let slug = el.node.slug
                  let auction = el.node.meta.auction_date ? `Auction ${moment(el.node.meta.auction_date).format('ddd D MMM')}` : false
                  let inspection = el.node.inspections?.length > 0 ? `Open ${moment(el.node.inspections[0].inspection_date).format('ddd D MMM')}` : false
                  let image = el.node.images?.length > 0 ? el.node.images[0].img_1200x : ''
                  if (el.node.meta.address_hide) {
                    title = el.node.meta.address_suburb
                    slug = `${el.node.meta.address_suburb.toLowerCase().replace(/ /gi, '-')}-${el.node.databaseId}`
                  }
                  let propertyProps = {
                    image: image,
                    address: title,
                    beds: el.node.meta.bedrooms ? el.node.meta.bedrooms : null,
                    baths: el.node.meta.bathrooms ? el.node.meta.bathrooms : null,
                    cars: el.node.meta.parking_total ? el.node.meta.parking_total : null,
                    price: el.node.meta.price_display ? el.node.meta.price_view : 'Contact Agent',
                    auction: auction,
                    inspection: inspection,
                    tag: '',
                    link: `/property/${el.node.meta.listing_id}/${slug}/`
                  }
                  return (
                    <div className='archive__item' key={i}>
                      <Fade bottom distance='30px'>
                        <PropertyCard {...propertyProps} />
                      </Fade>
                    </div>
                  )
                })}
              </div>
            </div>
          </section>
        }
        <Cta {...singlePropertyCta} />
        <div className={`agent__form ${enquiry ? 'active' : ''}`}>
          <div className='agent__form-wrapper'>
            <div className='agent__form-header'>
              <h4>Enquiry about this property</h4>
            </div>
            <PropertyForm
              listing_id={property.meta.listing_id}
              title={property.title}
            />
            <button
              className='btn btn--cancel'
              type='button'
              onClick={() => this.setState({ enquiry: !enquiry })}
            >
              Cancel
            </button>
          </div>
        </div>
      </>
    )
  }
}
//$agent_email: String!
export const propertyQuery = graphql`
  query ($id: String!, $agent_id_1: Int!, $agent_id_2: Int!, $agent_id_3: String!, $agent_id_4: String!, $client_id: Int!, $property_status: String!, $priceLower: Float!, $priceUpper: Float!) {
    wpProperty(id: {eq: $id}) {
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
        }
        schema {
          raw
        }
      }
      slug
      title
      images {
        img
      }
      area {
        area
        area_unit
      }
      inspections {
        inspection_date
        inspection_start_time
        inspection_end_time
      }
      media {
        content_type
        url
        usage
      }
      meta {
        listing_id
        agent_id_1
        agent_email_1
        address_sub_number
        address_street_number
        address_street_name
        address_street_type
        address_postcode
        address_suburb
        address_state
        address_hide
        property_status
        modify_date
        publish_date
        date_available
        bedrooms
        bathrooms
        parking_total
        floorplan
        latitude
        longitude
        headline
        description
        price_display
        price
        price_view
        property_type
        listing_type
        auction_date
        auction_time
        sold_details_sold_price_display
        sold_details_sold_price
        sold_details_sold_date
      }

      acf {
        videoUrl
      }
    }
    agent1: wpTeam(teamData: {agent_id: {eq: $agent_id_1}}) {
      title
      slug
      teamData {
        agent_id
        mobile
        email
      }
      acf {
        thumbnailImage {
          sourceUrl
        }
        jobTitle
        mobile
        email
      }
    }
    agent2: wpTeam(teamData: {agent_id: {eq: $agent_id_2}}) {
      title
      slug
      teamData {
        agent_id
        mobile
        email
      }
      acf {
        thumbnailImage {
          sourceUrl
        }
        jobTitle
        mobile
        email
      }
    }
    agent3: wpTeam(acf: {agentIds: {regex: $agent_id_3}}) {
      title
      slug
      teamData {
        agent_id
        mobile
        email
      }
      acf {
        thumbnailImage {
          sourceUrl
        }
        jobTitle
        mobile
        email
      }
    }
    agent4: wpTeam(acf: {agentIds: {regex: $agent_id_4}}) {
      title
      slug
      teamData {
        agent_id
        mobile
        email
      }
      acf {
        thumbnailImage {
          sourceUrl
        }
        jobTitle
        mobile
        email
      }
    }
    related: allWpProperty(
      sort: {meta: {publish_date: DESC}}
      filter: {
        meta: {
          price: {gt: $priceLower, lt: $priceUpper},
          property_status: {eq: $property_status},
          client_id: {eq: $client_id}
        },
        id: {ne: $id}
      }
      limit: 3
    ) {
      edges {
        node {
          databaseId
          id
          slug
          title
          images {
            img_1200x
          }
          inspections {
            inspection_date
            inspection_start_time
            inspection_end_time
          }
          meta {
            listing_id
            bathrooms
            bedrooms
            parking_total
            category
            price_display
            price_view
            price
            headline
            address_hide
            address_street_name
            address_street_number
            address_street_type
            address_suburb
            address_lot_number
            auction_date
            auction_time
            agent_email_1
            description
            publish_date
          }
        }
      }
    }
    wp {
      siteSettings {
        acf {
          snapshotCta {
            content
            desktopImage {
              sourceUrl
            }
            mobileImage {
              sourceUrl
            }
          }
          singlePropertyCta {
            title
            content
            buttons {
              button {
                text
                link
              }
            }
            desktopImage {
              sourceUrl
            }
            mobileImage {
              sourceUrl
            }
          }
        }
      }
    }
  }
`

export default PropertyTemplate
